export const SET_INITIAL_MEMBER_STATE = "SET_INITIAL_MEMBER_STATE";
export const RESET_BOOK_RESPONSE = "RESET_BOOK_RESPONSE";
export const RESET_FORM_TYPE = "RESET_FORM_TYPE";
export const SET_VISIT_TYPE = "SET_VISIT_TYPE";
export const SET_POSTAL_BTN_ENABLE = "SET_POSTAL_BTN_ENABLE";
export const SET_INCLUDED_MEMBER = "SET_INCLUDED_MEMBER";
export const SET_PINCODE = "SET_PINCODE";
export const SET_TPA_DETAILS = "SET_TPA_DETAILS";
export const SET_DC_LIST = "SET_DC_LIST";
export const SET_SHOW_VISIT_TYPE = "SET_SHOW_VISIT_TYPE";
export const SET_SELECTED_CENTER_TYPE = "SET_SELECTED_CENTER_TYPE";
export const SET_APPOINTMENT_DATE_TYPE = "SET_APPOINTMENT_DATE_TYPE";
export const SET_MOBILE_TYPE = "SET_MOBILE_TYPE";
export const SET_EMAIL_TYPE = "SET_EMAIL_TYPE";
export const SET_ADDRESS_TYPE = "SET_ADDRESS_TYPE";
export const SET_APPOINTMENT_TIME_TYPE = "SET_APPOINTMENT_TIME_TYPE";
export const SET_IS_MODAL_OPEN_TYPE = "SET_IS_MODAL_OPEN_TYPE";
export const SET_ERROR_TYPE = "SET_ERROR_TYPE";
export const SET_CITY_TYPE = "SET_CITY_TYPE";
export const SET_HOME_PINCODE_TYPE = "SET_HOME_PINCODE_TYPE";
